import { useState } from "react";
import { LayoutDashboard, Boxes, Package, FolderDown, Sparkles, ArrowRight, X } from "lucide-react";

const STEPS = [
  { icon: LayoutDashboard, title: "Welcome to your Client Portal", color: "bg-[#3B82F6]",
    text: "Everything about your business with Hi-Tech Silico, in one place — live order tracking, quotations, invoices, documents and more. Here's a 30-second tour." },
  { icon: Boxes, title: "Explore the Catalogue", color: "bg-[#8B5CF6]",
    text: "Browse our full range of silicone products with specs, features and photos. Found what you need? Hit Request Quote and our team gets it instantly." },
  { icon: Package, title: "Track Orders Live", color: "bg-[#FC5F5F]",
    text: "Watch every order move through production, quality check, packing and dispatch — with transporter & LR details, and one-click reorder." },
  { icon: FolderDown, title: "Quotations, Invoices & Documents", color: "bg-emerald-600",
    text: "Accept quotations online, check your balance, and download invoices & test certificates anytime." },
  { icon: Sparkles, title: "Meet your AI Assistant", color: "bg-[#3B82F6]",
    text: "Ask anything — \"Where is my order?\", \"What's my balance?\", or \"Which tube suits food-grade use?\" — and get instant answers, 24×7." },
];

export const PortalOnboarding = ({ onFinish, onOpenAi }) => {
  const [step, setStep] = useState(0);
  const s = STEPS[step];
  const Icon = s.icon;
  const last = step === STEPS.length - 1;
  const finish = (openAi) => { localStorage.setItem("portal_welcome_v1", "1"); onFinish(); if (openAi) onOpenAi(); };

  return (
    <div className="fixed inset-0 z-[70] bg-[#3B82F6]/60 backdrop-blur-sm flex items-center justify-center px-4" data-testid="portal-onboarding">
      <div className="bg-white rounded-3xl w-full max-w-md p-8 relative fade-up">
        <button onClick={() => finish(false)} className="absolute top-4 right-4 p-1.5 text-slate-400 hover:text-slate-700" data-testid="onboarding-skip"><X size={16} /></button>
        <div className={`w-14 h-14 rounded-2xl ${s.color} text-white flex items-center justify-center shadow-lg`}>
          <Icon size={24} strokeWidth={1.5} />
        </div>
        <h2 className="font-display text-2xl font-light text-slate-900 tracking-tight mt-5">{s.title}</h2>
        <p className="text-sm text-slate-500 leading-relaxed mt-3 min-h-[72px]">{s.text}</p>
        <div className="flex items-center gap-1.5 mt-5">
          {STEPS.map((_, i) => (
            <span key={i} className={`rounded-full transition-all duration-300 ${i === step ? "w-6 h-1.5 bg-[#3B82F6]" : "w-1.5 h-1.5 bg-slate-200"}`} />
          ))}
        </div>
        <div className="flex items-center justify-between mt-6">
          <button onClick={() => finish(false)} className="text-xs text-slate-400 hover:text-slate-600" data-testid="onboarding-skip-text">Skip tour</button>
          {last ? (
            <div className="flex gap-2">
              <button onClick={() => finish(false)} className="text-sm border border-slate-200 rounded-full px-5 py-2.5 text-slate-600 hover:border-slate-400" data-testid="onboarding-done">Done</button>
              <button onClick={() => finish(true)} className="inline-flex items-center gap-1.5 bg-[#3B82F6] hover:bg-[#2563EB] text-white rounded-full px-5 py-2.5 text-sm font-semibold" data-testid="onboarding-open-ai">
                <Sparkles size={13} /> Try the Assistant
              </button>
            </div>
          ) : (
            <button onClick={() => setStep(step + 1)} className="inline-flex items-center gap-1.5 bg-[#3B82F6] hover:bg-[#2563EB] text-white rounded-full px-6 py-2.5 text-sm font-semibold" data-testid="onboarding-next">
              Next <ArrowRight size={13} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
